export default "__VITE_ASSET__DXKQFa24__"